module.exports = __webpack_public_path__ + "static/intro-background-mobile-4e1b432f53c57b1732c947fc18059090.jpg";